export default __webpack_public_path__ + "static/media/relationships@2x.b9f1751d.png";